<div class="content-bar-header-title maintenance-message" *ngIf="showMaintenanceMessage">{{ maintenanceMessage }}</div>
<mat-toolbar color="primary">
  <div class="logo-container" [routerLink]="['/']">
    <img class="logo" src="{{ logo }}" alt="Content Platform" />
  </div>
  
 <div *ngIf="appTitle" class="app-title" [routerLink]="['/']">
    {{ appTitle }}{{!!subTitle && subTitle.trim().length > 0 ? ' - ' + subTitle : ''}}
  </div> 

  <ng-container *ngIf="isLoggedIn$ | async">
    <div class="spacer"></div>
    <div class="search" *ngIf="isSearchEnabled">
      <mat-form-field *ngIf="searchFilter.length > 0">
        <mat-select *ngIf="searchFilter" multiple (selectionChange)="filterOptionSelected($event)"
        [(ngModel)]="selectedFilterOption" placeholder="Filter Search By...">
          <mat-option value="All">All</mat-option>
          <mat-option *ngFor="let option of searchFilter" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="search-bar is-full-width" [floatLabel]="floatPlaceHolder">
        <input matInput placeholder="{{ searchPlaceHolderText }}" class="search__input" [matAutocomplete]="auto" [formControl]="searchCtrl">
        <button mat-button matSuffix mat-icon-button aria-label="Clear" *ngIf="searchCtrl.value" (click)="clearSearchText()">
          <mat-icon>cancel</mat-icon>
        </button>
        <ng-content></ng-content>
        <mat-autocomplete class="auto-complete" #auto="matAutocomplete" (optionSelected)="optionSelected(searchCtrl.value)"
        [displayWith]="displayFn" [panelWidth]="400">
          <div *ngIf="searchCtrl.value">
            <mat-option *ngFor="let item of (searchResults | async)" [value]="item" class="search-result__item">
              <div class="item">
                <div *ngIf="highlightSearch; else showsearch" innerHTML="{{ item.name | highlight : searchCtrl.value}}"></div>
                <ng-template #showsearch>{{ item.name }}</ng-template>
              </div>
              <span *ngIf="searchHasTags && item.type" class="search-result__tag" [ngClass]="item.type.toLowerCase()"> {{ item.type }} </span>
            </mat-option>
          </div>
          <div class="correction-text" *ngIf="searchCtrl.value && (searchCorrectionResults | async)?.length > 0">
            <span>Are you looking for?</span>
            <mat-option *ngFor="let item of (searchCorrectionResults | async)" [value]="item" class="search-result__item">
              <div class="item">
                <div *ngIf="highlightSearch; else showsearch" innerHTML="{{ item.name }}"></div>
                <ng-template #showsearch>{{ item.name }}</ng-template>
              </div>
              <span *ngIf="searchHasTags && item.type" class="search-result__tag" [ngClass]="item.type.toLowerCase()"> {{ item.type }} </span>
            </mat-option>
          </div>
        </mat-autocomplete>

      </mat-form-field>

      <mat-icon>search</mat-icon>
    </div>
    <ng-content select="[additional-icons]"></ng-content>
    <app-applications-menu *ngIf="isAppMenuShow && (applications$ | async)?.length > 0" [applications]="applications$ | async" (switchApp)=switchApp($event)></app-applications-menu>
    <app-user-menu  [user]="user$ |async" (logout)="logout()" [additionalMenuItems]="additionalMenuItems"></app-user-menu>
  </ng-container>
</mat-toolbar>
